import React from 'react';
import PropTypes from 'prop-types';

import { PromotionCardSkeleton } from '@atlas/ui';

const PromotionsCardSkeleton = ({ children, imageHeight, loading }) => {
  if (loading) {
    return <PromotionCardSkeleton cardNum={4} imageHeight={imageHeight} />;
  }

  return children;
};

PromotionsCardSkeleton.propTypes = {
  children: PropTypes.node,
  imageHeight: PropTypes.number,
  loading: PropTypes.bool,
};

export default PromotionsCardSkeleton;
